<div class="d-flex justify-content-between align-items-center mb-3">
  <p class="f-14 font-weight-600 mb-0">Tagged to Talent pool</p>
  <!-- <button data-testid="auto-app-taggedto-tab-button-1" class="btn-trms-light" (click)="addtoTalentpool()"><i class="fas fa-plus"></i> Add To Talent pool</button> -->
</div>
<div>
  <div class="mb-2 d-flex align-items-start" *ngFor="let talentpool of candidatedata?.talentpools">
    <span class="mr-2">
      <span class="note-icon"> <i class="fa-regular fa-users"></i></span>
    </span>
    <div class="w-100">
      <div class="d-flex justify-content-between mb-1">
        <div class="f-14 font-weight-500">{{talentpool?.name}}</div>
        <div class="f-14 font-weight-500"><i class="fa-light fa-users mr-2"></i> {{talentpool?.talentpoolcount}}</div>
      </div>
      <div class="d-flex justify-content-between">
        <div class="f-12 font-weight-500 text-9696"></div>

        <div class="f-12 font-weight-500 text-9696">{{talentpool?.firstname}} {{talentpool?.lastname}}<i
            class="fas fa-circle f-10 mx-3" style="font-size: 5px;"></i>{{talentpool?.createdon | date: 'dd MMM yyyy'}}
        </div>
      </div>
    </div>

  </div>
  <hr class="my-4">
</div>
<div class="d-flex justify-content-between align-items-center mb-3" *ngIf="candidatedata?.emailcampaigns.length>0">
  <p class="f-14 font-weight-600 mb-0">Tagged to Email Campign</p>
  <!-- <button data-testid="auto-app-taggedto-tab-button-2" class="btn-trms-light" (click)="open()"><i class="fas fa-plus"></i> Add To Email Campaign</button> -->
</div>
<div class="mb-6">
  <div class="mb-3 d-flex align-items-start" *ngFor="let campaign of candidatedata?.emailcampaigns">
    <span class="mr-2">
      <span class="ats-cta-btn"> <i class="fa-solid f-16 fa fa-envelopes-bulk text-webbtree-green pointer activity-icon"></i></span>
    </span>
    <div class="w-100">
      <div class="d-flex justify-content-between mb-1">
        <div class="f-14 font-weight-500">{{campaign?.campaign_name}}</div>
        <div class="f-14 font-weight-500"><i class="fa-light fa-users mr-2"></i> {{campaign?.candidate_count}}</div>
      </div>
      <div class="d-flex justify-content-end">
        <div class="f-12 font-weight-500 text-9696">{{campaign?.firstname}} {{campaign?.lastname}}<i
            class="fas fa-circle f-10 mx-3" style="font-size: 5px;"></i>{{campaign?.created_on | date: 'dd MMM yyyy'}}
        </div>
      </div>
    </div>
  </div>
</div>
<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
